/**
 * Layout Primitives — raw layout values, breakpoints, z-index scale, and icon sizes.
 */

export const layoutValues = {
  navBarWidth: "85px",
  navBarExpandedWidth: "350px",
  pageMargin: "50px",
  vizPadding: "30px",
  controlsHeight: "34px",
  menuMaxHeight: "200px",
} as const;

export const breakpointValues = {
  xxs: 500,
  xs: 640,
  sm: 800,
  md: 900,
  lg: 1100,
  xxl: 1250,
} as const;

/** Component-specific breakpoints — not part of the global scale. */
export const componentBreakpointValues = {
  headerMobile: 700,
  tableCompact: 950,
} as const;

export const breakpointHeightValues = {
  sm: 500,
  md: 550,
  lg: 768,
} as const;

export const zIndex = {
  base: 1,
  above: 2,
  tooltip: 50,
  legendItem: 40,
  dropdown: 100,
  panel: 999,
  navigation: 1000,
  settingsDropdown: 2000,
  overlay: 3000,
  mobileNotification: 3001,
  glossaryOverlay: 4000,
} as const;

export type IconSize = "xs" | "sm" | "md" | "lg" | "xl";

export const iconSize: Record<IconSize, string> = {
  xs: "12px",
  sm: "16px",
  md: "20px",
  lg: "24px",
  xl: "32px",
};
